import Overlays from './Overlays';


/**
 * @type { import('didi').ModuleDeclaration }
 */
export default {
  __init__: [ 'overlays' ],
  overlays: [ 'type', Overlays ]
};